<template>
  <div class="phone">04 28 29 65 94</div>
</template>

<script>
export default {
  name: 'phone',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/topbar/phone.vue